import { TextBox } from "devextreme-react";
import { Button } from "devextreme-react/button";
import { useState } from "react";
import Dialog from "./Dialog";
import { useAsyncFn } from "react-use";
import repository from "../auth/AuthService";
import { Alert } from "react-bootstrap";
import LoadingIndicator from "../LoadingIndicator";
const AuthDialog = ({ setIsOpen, isOpen, onAuthenticated, value }) => {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();

  const [state, onSubmit] = useAsyncFn(async (data) => {
    await repository.hasAccess(data);
    onAuthenticated(value);
  }, []);

  return (
    <div>
      <Dialog
        title="Konfirmasi"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div class="font-medium text-sm dx-theme-text-color">Username</div>
        <div className="w-full mt-2">
          <TextBox onValueChanged={({ value }) => setUsername(value)} />
        </div>
        <div class="font-medium text-sm mt-2 dx-theme-text-color">Password</div>
        <div className="w-full mt-2">
          <TextBox onValueChanged={({ value }) => setPassword(value)} />
        </div>

        {state.error && !state.loading ? (
          <Alert className="mt-2">{state.error.response.data.message}</Alert>
        ) : null}
        {state.loading ? (
          <LoadingIndicator />
        ) : (
          <Button
            className="w-full mt-4"
            text="confirm"
            stylingMode="contained"
            type="default"
            onClick={() =>
              onSubmit({
                username: username,
                password: password,
              })
            }
          />
        )}
      </Dialog>
    </div>
  );
};

export default AuthDialog;
